const generateSrcset = (image, widths = []) => {
  const imageUrl = new URL(image["src"]);
  return widths
    .filter((width) => width <= image["width"])
    .map((width) => {
      imageUrl.searchParams.set("width", width.toString());
      return `${imageUrl.href} ${width}w`;
    })
    .join(", ");
};

/** @returns {string} product handle from a store-relative or absolute product URL */
function productHandleFromHref(href) {
  if (!href) return "";
  const path = String(href).split("?")[0].split("#")[0];
  const match = path.match(/\/products\/([^/?#]+)/);
  return match ? match[1] : "";
}

function buildProductUrlWithVariant(baseHref, variantId) {
  if (!baseHref || !variantId) return baseHref;
  const [pathPart, queryPart = ""] = String(baseHref).split("?");
  const params = new URLSearchParams(queryPart);
  params.set("variant", String(variantId));
  const q = params.toString();
  return q ? `${pathPart}?${q}` : pathPart;
}

const createImageElement = (image, classes, sizes, productTitle) => {
  const previewImage = image["preview_image"];
  const newImage = new Image(previewImage["width"], previewImage["height"]);
  newImage.className = classes;
  newImage.alt = image["alt"] || productTitle;
  newImage.sizes = sizes;
  newImage.src = previewImage["src"];
  newImage.srcset = generateSrcset(
    previewImage,
    [165, 360, 533, 720, 940, 1066]
  );
  newImage.loading = "lazy";
  return newImage;
};

function swapPrimaryImage(
  wrapper,
  product,
  variant,
  primaryImage,
  secondaryImage
) {
  if (!variant.featured_media) return;

  const newPrimaryImage = createImageElement(
    variant["featured_media"],
    primaryImage.className,
    primaryImage.sizes,
    product.title
  );

  if (newPrimaryImage.src === primaryImage.src) return;

  let reusedSecondary = false;
  if (secondaryImage) {
    const secondaryPath = new URL(secondaryImage.src).pathname;
    const newPrimaryPath = new URL(newPrimaryImage.src).pathname;
    if (secondaryPath === newPrimaryPath) {
      primaryImage.remove();
      secondaryImage.classList.remove("media--second");
      secondaryImage.classList.add("media--first");
      reusedSecondary = true;
    }
  }

  if (reusedSecondary) return;

  primaryImage.animate(
    { opacity: [1, 0] },
    { duration: 200, easing: "ease-in", fill: "forwards" }
  );
  setTimeout(() => {
    primaryImage.replaceWith(newPrimaryImage);
    newPrimaryImage.animate(
      { opacity: [0, 1] },
      { duration: 200, easing: "ease-in" }
    );
    if (secondaryImage) secondaryImage.remove();
  }, 200);
}

function handleCardColorSwatchChange(input) {
  const wrapper = input.closest(".js-color-swatches-wrapper");
  if (!wrapper || !input.checked) return;

  const linkEl = wrapper.querySelector(".js-color-swatches-link");
  if (!linkEl) return;

  const variantId = input.dataset.variantId;
  const optionProductUrl = input.dataset.productUrl;
  const defaultHandle = wrapper.dataset.product || "";

  const baseHref = (
    optionProductUrl ||
    linkEl.getAttribute("href") ||
    ""
  ).split("?")[0];

  if (variantId) {
    linkEl.setAttribute(
      "href",
      buildProductUrlWithVariant(baseHref, variantId)
    );
  } else if (optionProductUrl) {
    linkEl.setAttribute("href", optionProductUrl);
  }

  const addVariantInput = wrapper.querySelector(
    '.card__add-to-cart input[name="id"]'
  );
  if (addVariantInput && variantId) {
    addVariantInput.value = variantId;
    addVariantInput.removeAttribute("disabled");
  }

  const primaryImage = wrapper.querySelector(".media--first");
  if (!primaryImage) return;

  const secondaryImage = wrapper.querySelector(".media--second");

  const fetchHandle =
    productHandleFromHref(optionProductUrl || linkEl.getAttribute("href")) ||
    defaultHandle;
  if (!fetchHandle) return;

  const root =
    window.Shopify?.routes?.root != null ? window.Shopify.routes.root : "/";
  const endpoint = `${root}products/${fetchHandle}.js`;

  fetch(endpoint)
    .then((r) => (r.ok ? r.json() : Promise.reject()))
    .then((product) => {
      const currentColor = input.value;
      let variant = null;

      if (variantId) {
        variant = product.variants.find(
          (v) => String(v.id) === String(variantId)
        );
      }
      if (!variant) {
        variant = product.variants.find(
          (item) =>
            item.featured_media != null && item.options.includes(currentColor)
        );
      }

      if (!variant) return;

      swapPrimaryImage(wrapper, product, variant, primaryImage, secondaryImage);
    })
    .catch(() => {});
}

let colorSwatchDelegationBound = false;

function bindColorSwatches() {
  if (colorSwatchDelegationBound) return;
  colorSwatchDelegationBound = true;

  document.addEventListener("change", (event) => {
    const target = event.target;
    if (!(target instanceof HTMLInputElement)) return;
    if (target.type !== "radio") return;
    if (!target.closest(".js-color-swatches")) return;
    handleCardColorSwatchChange(target);
  });
}

(function () {
  bindColorSwatches();
  document.addEventListener("shopify:section:load", bindColorSwatches);
})();
